import { LazyLoading } from "@/controls/LazyLoading";
import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2 as Grid } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo } from "react";
import { useProcesssReportContext } from "../context/ProcesssDataReportContext";
import { ProcessData } from "../models/ProcesssData";
import { useGridStyles } from "../styles/gridStyles";
import { useTableData } from "./hooks";

type Props = {
	loadingGrid: boolean;
	rows: ProcessData[];
	refreshData: Function;
	gridRef: React.RefObject<AgGridReact>;
};

export const ProcesssReportTable = ({ loadingGrid, rows, gridRef }: Props) => {
	const gridStyles = useGridStyles();
	const { columns } = useTableData();

	const {
		state: { errorMessage },
		actions: { setErrorMessage },
	} = useProcesssReportContext();

	const loadingOverlayComponent = useMemo<any>(() => {
		return LazyLoading;
	}, []);

	useEffect(() => {
		if (loadingGrid) {
			gridRef.current?.api?.showLoadingOverlay();
		} else {
			gridRef.current?.api?.hideOverlay();
		}
	}, [loadingGrid]);

	return (
		<div onContextMenu={(e) => e.preventDefault()}>
			<div>
				<Grid size={{ xs: 12, md: 12 }} container>
					<Grid
						size={{ xs: 12, md: 12 }}
						style={{
							borderRadius: 10,
							height: "calc(100vh - 300px)",
							minHeight: "calc(100vh - 300px)",
							border: "1px solid #E0E0E0",
						}}
					>
						<AgGridReact
							ref={gridRef}
							rowSelection="single"
							pagination={false}
							animateRows={true}
							loadingOverlayComponent={loadingOverlayComponent}
							singleClickEdit={true}
							rowData={rows}
							columnDefs={columns}
							suppressContextMenu={true}
							getRowId={(params) => params.data.ProcessId}
						/>
					</Grid>
				</Grid>
			</div>
			<ErrorModal error={errorMessage} onHide={() => setErrorMessage("")} />
		</div>
	);
};
